import type { FandomTaxonomyTargeting } from "../types";
import { TAXONOMY_NEW_KEYS_CONFIGURATION } from "./../consts";
import { filterValues } from "./../FandomTaxonomyHelpers";
import { getTaxonomyValueForKey } from "./getTaxonomyValueForKey";
export function getTaxonomyKeyValues(): FandomTaxonomyTargeting {
  const kv: Record<string, string[]> = Object.keys(
    TAXONOMY_NEW_KEYS_CONFIGURATION,
  ).reduce(
    (acc, key) => {
      acc[key] = getTaxonomyValueForKey(TAXONOMY_NEW_KEYS_CONFIGURATION[key]);
      return acc;
    },
    {} as Record<string, string[]>,
  );

  return filterValues(kv) as FandomTaxonomyTargeting;
}
